import PrimaryButton, {
    SecondaryButton,
} from "@/components/atoms/Button/Button"
import { Link } from "@inertiajs/react"
import { Transition } from "@headlessui/react"

export default function CookieConsentBanner({
    show,
    acceptCallback,
    denyCallback,
}: {
    show?: boolean
    acceptCallback: () => void
    denyCallback: () => void
}) {
    return (
        <Transition
            appear
            show={show}
            enter="transition-transform duration-300 ease-out"
            enterFrom="translate-y-full"
            enterTo="translate-y-0"
            leave="transition-transform duration-200 ease-in"
            leaveFrom="translate-y-0"
            leaveTo="translate-y-full"
        >
            <div
                id="cookie-banner"
                className={`
                    fixed bottom-0 left-0 right-0 z-50 flex flex-wrap
                    items-center justify-center gap-6 rounded-t-xl bg-bonza-dark
                    p-4

                    md:justify-between md:p-8
                `}
                role="dialog"
                aria-live="polite"
            >
                <div className={"flex flex-col gap-2"}>
                    <p className={"text-bonza-pale"}>
                        We use cookies and similar technologies{" "}
                        <span className={`italic`}>(“Cookies”)</span> on our
                        website and through our apps for performance, analytical
                        or advertising purposes to ensure you have the very best
                        experience on our sites and/or interaction with us.
                    </p>
                    <span className={"text-bonza-pale-t-70"}>
                        To find out more about the use of Cookies, please see
                        our{" "}
                        <Link
                            className={`
                                text-bonza-primary

                                hover:text-inherit
                            `}
                            href={route("web.legal", { cookie: 1 })}
                        >
                            cookie policy
                        </Link>
                    </span>
                    <span className={"text-bonza-pale-t-70 text-sm italic"}>
                        Please click “Accept” if you consent to our use of all
                        Cookies, or click “Reject Non-essential” to reject our
                        use of non-essential Cookies.{" "}
                    </span>
                </div>
                <div className={"flex gap-4"}>
                    <SecondaryButton onClick={denyCallback}>
                        Reject Non-essential
                    </SecondaryButton>
                    <PrimaryButton onClick={acceptCallback} className={"px-12"}>
                        Accept
                    </PrimaryButton>
                </div>
            </div>
        </Transition>
    )
}
